import IGrauDeInstrucao from '../../interfaces/IGrauDeInstrucao';
import IGrauDeInstrucaoParaSelect from '../../interfaces/IGrauDeInstrucaoParaSelect';

export const mapearGrauDeInstrucaoParaSelect = (grauDeInstrucoes: IGrauDeInstrucao[]): IGrauDeInstrucaoParaSelect[] =>
  grauDeInstrucoes.map(({ id, nome }) => ({
    value: id,
    label: nome
  }));